module.exports = __webpack_public_path__ + "50b628c296e7af456d0c4a89e8feed7d.png";